import { FormioAppConfig } from "@formio/angular";

declare const window: any;
export const environment = {
  production: true,
};

export const AppConfig: FormioAppConfig = {
  appUrl: window["env"]["formgen_app_url"],
  apiUrl: window["env"]["formgen_api_url"],
  icons: window["env"]["formgen_icon"]
};

export const EnvConfig: any = {
  appUrl: window["env"]["appUrl"],
  backendUrl: window["env"]["backendUrl"],
  formId: window["env"]["formId"],
  jwt_user: window["env"]["jwt_user"],
  jwt_password: window["env"]["jwt_password"],
  formio_auth_token: window["env"]["formio_auth_token"],
  matomoSiteId: window["env"]["matomo_site_id"],
  matomoTrackerUrl: window["env"]["matomo_tracker_url"],
  env: window["env"]["env"],
  version: window["env"]["version"],
  auth_SPID: window["env"]["auth_SPID"],
  sso_url: window["env"]["sso_url"],
  sso_realm: window["env"]["realm"],
  sso_clientId: window["env"]["clientId"],
}
